<template>
	<div class="about">
		<div class="settingwarp">
			<header>
				<div style="display: block;">
					<div class="cu-custom" style="height: 45px;">
						<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
							<div class="content text-gold" style="top: 0px;">
								<div>{{$t('guanyuwomen')}}</div>
							</div>
							<div class="action" @click="changego">
								<text class="cuIcon-back" style="width: 50px;">
									<span></span>
								</text>
							</div>
						</div>
					</div>
				</div>
			</header>
		</div>
		<div class="padding bg-black text-gold">
			<rich-text>
				<div style="position: relative;font-size: 17px;">
					<p>{{$t('textee1')}}</p>
					<!-- <br> -->
					<p>{{$t('textee2')}}</p>
					<p>{{$t('textee3')}}</p>
					<!-- 	<br> -->
					<p>{{$t('textee4')}}</p>
					<!-- 	<br> -->
					<p>{{$t('textee5')}}</p>
					<!-- 		<br> -->
					<p>{{$t('textee6')}}</p>
					<!-- 		<br> -->
					<p>{{$t('textee7')}}</p>
					<!-- 	<br> -->
					<p>{{$t('textee8')}}</p>
					<p>{{$t('textee9')}}</p>
					<!-- <br> -->
					<p>{{$t('textee10')}}</p>
					<p>{{$t('textee11')}}</p>
					<!-- 		<br> -->
					<p>{{$t('textee12')}}</p>
					<p>{{$t('textee13')}}</p>
					<p>{{$t('textee14')}}</p>
					<p>{{$t('textee15')}}</p>
					<!-- 	<br> -->
					<p><strong class="ql-size-large">{{$t('textee16')}}</strong></p>
					<!-- 		<br> -->
					<p>{{$t('textee17')}}</p>
					<!-- 	<br> -->
					<p>{{$t('textee18')}}</p>
					<!-- 			<br> -->
					<p>{{$t('textee19')}}</p>
					<!-- 		<br> -->
				<!-- 	<p>{{$t('textee20')}}</p> -->
				<!-- 	<p>{{$t('textee21')}}{{email}}</p> --><uni-resize-sensor>
						<div>
							<div></div>
						</div>
						<div>
							<div></div>
						</div>
					</uni-resize-sensor>
				</div>
			</rich-text>
		</div>
	</div>
</template>
<script>
	export default {
		name: "About",
		components: {},
		data() {
			return {
				email: 'support-gold@fgold.org'
			};
		},
		methods: {
			changego() {
				this.$router.go(-1);
			},
		},
	};
</script>
<style lang="less" scoped>
	.g-content {
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
		overflow: scroll;
		text-align: center;
		color: #a0a0a0;
	}

	.logo-box {
		margin-top: 3rem;
	}

	.logo {
		width: 1.8rem;
		height: 1.8rem;
	}

	.version {
		margin-top: 0.4rem;
		font-size: 0.4rem;
	}

	.copyright {
		position: absolute;
		width: 100%;
		bottom: 0.6rem;
		font-size: 0.4rem;
	}

	.cuIcon-back:before {
		content: "\e679";
	}

	.cu-bar .action:first-child {
		margin-left: 17px;
		font-size: 17px;
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-bar .action:first-child>text[class*="cuIcon-"] {
		margin-left: -.3em;
		margin-right: .3em;
	}

	.cu-bar .action>text[class*="cuIcon-"],
	.cu-bar .action>div[class*="cuIcon-"] {
		font-size: 20px;
	}

	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.bg-black {
		background-color: #333;
		color: #fff;
	}

	.padding {
		padding: 17px;
	}

	.div {
		box-sizing: border-box;
		display: block;
	}

	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	p {
		display: block;
		margin-block-start: 1em;
		margin-block-end: 1em;
		margin-inline-start: 0px;
		margin-inline-end: 0px;
		unicode-bidi: isolate;
	}

	body {
		background-color: #f1f1f1;
		font-size: 16px;
		color: #333;
		font-family: Helvetica Neue, Helvetica, sans-serif;
	}
</style>